import { render, staticRenderFns } from "./PayrollElem.vue?vue&type=template&id=301c6f76&scoped=true&"
import script from "./PayrollElem.vue?vue&type=script&setup=true&lang=js&"
export * from "./PayrollElem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301c6f76",
  null
  
)

export default component.exports